import { render, staticRenderFns } from "./CarnivalTable.vue?vue&type=template&id=d678552a&scoped=true"
import script from "./CarnivalTable.vue?vue&type=script&lang=js"
export * from "./CarnivalTable.vue?vue&type=script&lang=js"
import style1 from "./CarnivalTable.vue?vue&type=style&index=1&id=d678552a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d678552a",
  null
  
)

export default component.exports